import React, { useState, useEffect } from "react";
import { FaTimes } from "react-icons/fa";
import { languages } from "../../admin/Packages/languages";
import { AddLanguageModalProps } from "../../Types/types";

export const AddLanguageModal: React.FC<AddLanguageModalProps> = ({
  isOpen,
  onClose,
  translations,
  mode,
  values,
  setValues,
}) => {
  const [localValues, setLocalValues] = useState(values);

  useEffect(() => {
    if (isOpen) {
      setLocalValues(values);
    }
  }, [isOpen, values]);

  if (!isOpen) return null;

  const title =
    mode === "name"
      ? translations.setPackageName
      : mode === "description"
      ? translations.setPackageDescription
      : translations.setStepName;

  const handleSave = () => {
    setValues(localValues);
    onClose();
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-[#586EDFCC]">
      <div className="bg-white rounded-lg shadow-lg p-4 w-full max-w-7xl relative mx-2 sm:mx-auto dark:bg-darkSecondaryBackground">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-500"
        >
          <FaTimes />
        </button>
        <div className="flex justify-center items-center mb-4">
          <h2 className="text-lg font-semibold">{title}</h2>
        </div>
        <form className="space-y-3">
          {languages.map((lang) => (
            <div key={lang.code} className="flex items-center gap-4">
              <img
                src={lang.flag}
                alt={`${lang.name} flag`}
                className="w-8 h-8 sm:w-10 sm:h-10"
              />
              <label className="block text-sm sm:text-base w-4">
                {`${lang.name}`}
              </label>
              <input
                type="text"
                className="w-full px-2 sm:px-3 py-1 sm:py-2 rounded-md border border-gray-300 shadow-sm focus:outline-none focus:ring-0 dark:bg-darkSecondaryBackground dark:border-purple"
                value={localValues[lang.code] || ""}
                onChange={(e) =>
                  setLocalValues({
                    ...localValues,
                    [lang.code]: e.target.value,
                  })
                }
              />
            </div>
          ))}
        </form>
        <div className="flex justify-end space-x-2 mt-4 sm:mt-6">
          <button
            type="button"
            className="bg-gray-300 text-gray-700 px-3 py-2 rounded font-medium shadow-sm dark:bg-white dark:text-black"
            onClick={onClose}
          >
            {translations.discard}
          </button>
          <button
            type="button"
            className="bg-purple text-white px-3 py-2 rounded font-medium shadow-sm"
            onClick={handleSave}
          >
            {translations.save}
          </button>
        </div>
      </div>
    </div>
  );
};
